export class FolhaDePagamento {}
